import SummaryLayoutWrapper from 'components/Content/BeautyInsider/BeautyInsiderSummary/SummaryLayoutWrapper/SummaryLayoutWrapper';

export default SummaryLayoutWrapper;
